import React from "react";
import StateInfoField from "../../../StudyRequestInfo/StateInfoField";

const EducationInfoCell = (cellData) => {
  let programId = cellData.key.programId;
  let program = cellData.key.programCode
    ? (cellData.key.programCode + ' | ' + cellData.key.programName)
    : cellData.key.programName;

  let orgName = cellData.key.orgName;
  let groupId = cellData.key.groupId;
  let groupCommercial = cellData.key.groupCommercial ? "платно" : "бесплатно";
  let groupCode = cellData.key.groupCode || '-';
  let dateStartEducation = cellData.key.dateStartEducation || '-';
  let dateEndEducation = cellData.key.dateEndEducation || '-';
  let educationPeriod = "c " + dateStartEducation + " по " + dateEndEducation;

  return (
    <div>
      <StateInfoField field="Программа" value={program}/>
      <StateInfoField field="Организация" value={orgName}/>
      <StateInfoField field="Группа" value={groupCode}/>
      <StateInfoField field="Период" value={educationPeriod}/>
      <StateInfoField field="Стоимость" value={groupCommercial}/>
    </div>
  );
}

export default EducationInfoCell;
